<template>
	<div class="sdfdff">
		<img src="@/assets/img-pc/v31.0808a585.svg">

		<swiperMode class="flex-1" :list="notices" :delay="5000" ref="swiperModeRef"></swiperMode>

		<div class="ckgd" style="margin-left: auto;">
			<img src="@/assets/img-pc/v32.03c79cb9.svg">
		</div>
	</div>
</template>
<script>
import swiperMode from './model1Swiper.vue';
export default {
	props: {
		data: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		swiperMode
	},
	computed: {
		notices() {
			return this.data.map(item => item.title)
		}
	},
	data() {
		return {
			// notices: [
			// "为什么选择Revolut？AI量化储蓄的优势",
			// "🔥 BTC 即将突破 120000 USDT",
			// "🎉 ETH 二层网络交易量创新高",
			// ],
		};
	},
	methods: {
		init(data = []) {
			this.notices = data.map(item => item.title)
		}
	},
};
</script>
<style lang="scss" scoped>
.sdfdff {
	color: #fff;
	width: 100%;
	margin: 20px auto 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 12px;
	height: 52px;
	border-radius: 32px;
	border: 2px solid hsla(0, 0%, 100%, .12);
	background: radial-gradient(114.2% 133.85% at 7.14% 3.6%, rgba(29, 55, 56, .49) .01%, rgba(35, 35, 54, .07) 100%);
	-webkit-backdrop-filter: blur(6px);
	backdrop-filter: blur(6px);
	padding: 0 20px;
}
</style>